
import RelationToOneField from '@/shared/fields/relation-to-one-field';
import { DecisionPurposeService } from '@/modules/decision-purpose/decision-purpose-service';

export class DecisionPurposeField {
    static relationToOne(name, label, rules, filterParams, children) {
        return new RelationToOneField(
            name,
            label,
            DecisionPurposeService.listAutocomplete,
            (record) => {
                if (!record) {
                    return '';
                }

                return {
                    value: record.id,
                    text: record.name,
                };
            },
            rules,
            filterParams,
            children
        );
    }
}
